import {
    Button,
    Step,
    StepLabel,
    Stepper,
    Tooltip,
    Typography,
} from "@material-ui/core";
import {
    Fragment,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { handleKeyDown } from "../../../common/common";
import { CounterPartyList } from "../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import { vesselCalculatorMainFields } from "../../../constants";
import { getCurrentUserId, toastError, toastSuccess } from "../../../utils";
import { getAddressDetails } from "../AddressBook/actions";
import { getGeneralMasterData } from "../Calculator/actions";
import { initialContractFields, initialVesselContractFields } from "../Calculator/Contracts";
import AddNewOrder from "../Orders/AddNewOrder";
import { createOperation } from "./action";

const formateCargoCargoContractData = (data, operationName, opsType) => {
    const cargolistdetails = []
    data?.cargoList?.forEach(element => {
        if (element?.operation?.toLowerCase() === "loading" || element?.operation?.toLowerCase() === "discharging") {
            cargolistdetails.push({
                label: element?.label,
                despatch: element?.despatch,
                voyType: element?.voyType,
                account: element?.account,
                firstLoadPort: element?.firstLoadPort,
                lastDischargePort: element?.lastDischargePort,
                cargo: element?.cargo,
                freight: element?.freight,
                profit: element?.profit,
                duration: element?.duration,
                freightMode: element?.freightMode,
                laycanBegin: element?.laycanBegin,
                laycanEnd: element?.laycanEnd,
                broker: element?.broker,
                lumpsumFreight: element?.lumpsumFreight,
                stowFactor: element?.stowFactor,
                multiParcelMode: element?.multiParcelMode,
                operation: element?.operation,
                port: element?.port,
                cargoQty: element?.cargoQty,
                tolerance: element?.tolerance,
                rate: element?.rate,
                terms: element?.terms,
                turnTime: element?.turnTime,
                pdaRemarks: element?.pdaRemarks,
                grade: element?.grade,
                adcom: element?.adcom,
                brokerage: element?.brokerage,
                ttlComm: element?.ttlComm,
                netFrt: element?.netFrt,
                factor: element?.factor,
                other: element?.other,
                index: element?.index,
                country: element?.country,
                portId: element?.portId,
                notes: element?.notes,
                ...element
            })
        }
    });
    const vesselVoyageData = []
    data?.cargoList?.forEach(element => {
        if (element?.operation?.toLowerCase() === "loading" || element?.operation?.toLowerCase() === "discharging") {
            vesselVoyageData.push({
                operation: element?.operation,
                port: element?.port,
                lat: element?.lat,
                lng: element?.lng,
                cargoQty: element?.cargoQty,
                cargo: element?.cargo,
                min: element?.min,
                max: element?.max,
                laycanStartDate: null,
                laycanEndDate: null,
                stowFactor: element?.stowFactor,
                actualCargoQty: 0,
                tolerance: element?.tolerance || 0,
                arrivalTime: null,
                departureTime: null,
                portStay: 0,
                ...element
            })
        }
    });

    const customerCargo = {
        ...data,
        cargoList: cargolistdetails,
    }
    const cargocargo = {
        customerCargo: customerCargo,
        vendorCargo: customerCargo,
        vesselVoyageData: vesselVoyageData,
        queryId: data?._id,
        organizationId: data?.organizationId,
        version: data?.version,
        system: data?.system,
        name: data?.name,
        miscExp: data?.miscExp,
        miscRevenue: data?.miscRevenue,
        laycanStartDate: data?.laycanStartDate,
        laycanEndDate: data?.laycanEndDate,
        remarkMessage: data?.remarkMessage,
        qtyMode: data?.qtyMode,
        freightMode: data?.freightMode,
        access: data?.access,
        firstLoadPort: data?.firstLoadPort,
        lastDischargePort: data?.lastDischargePort,
        cargo: data?.cargo,
        loadQty: data?.loadQty,
        createdUser: data?.createdUser,
        label: data?.label,
        voyType: data?.voyType,
        account: data?.account,
    }
    let contractData = initialContractFields;
    contractData.cargoDetails = cargocargo
    contractData.status = "close"
    contractData.access = "private"
    contractData.contractType = opsType;
    contractData.contractName = operationName;
    return {
        ...contractData,
        actualCargoContract: contractData,
        operationCargoContract: contractData,
    }
}

const formateVesselVesselContractData = (data, operationName, opsType) => {
    const { vesselOutContract, ...base } = initialVesselContractFields;
    const finalData = {
        ...base,
        vesselDetails: data,
        contractType: opsType,
        contractName: operationName,
        status: "close",
        access: "private",
        vesselOutContract: {
            ...base,
            vesselDetails: data,
            contractType: opsType,
            contractName: operationName
        }
    }
    return {
        ...finalData,
        actualVesselContract: finalData,
        operationVesselContract: finalData
    };
};


const formateVesselCargoContractData = (vesseldata, cargodata, operationName, opsType) => {
    const { vesselOutContract, ...base } = initialVesselContractFields;

    const vesselContractData = {
        ...base,
        vesselDetails: vesseldata,
        contractType: opsType,
        contractName: operationName,
        status: "close",
        access: "private",
    };

    const cargoContractData = formateCargoCargoContractData(cargodata, operationName, opsType)

    return {
        vesselContractData: {
            ...vesselContractData,
            operationVesselContract: vesselContractData,
            actualVesselContract: vesselContractData,
        },
        cargoContractData
    };
};

const VesselConsumptions = ({
    parsedVesselData,
    selectedVessel,
    setSelectedVessel,
    analysisVessel,
}) => {
    const seaConsumptionRows = [1, 2, 3, 4];

    const portConsumptionRows = [
        { label: "Idle", prefix: "vesselPIdle" },
        { label: "Loading", prefix: "vesselPLdg" },
        { label: "Disch", prefix: "vesselPDisch" },
        {
            label: "Extra",
            prefix: "vesselVExtra",
            tooltip: "Any Additional Lumpsum Consumption in the entire voyage",
        },
    ];

    return (
        <div className="w-full pt-2.5 pb-1">
            {/* Top Vessel Selector & Properties Bar */}
            <div className="mb-1 p-1 bg-white rounded-none flex flex-wrap items-center justify-between gap-1.5">
                <div className="flex items-center gap-2 flex-grow sm:flex-grow-0">
                    <span className="text-[11px] font-medium text-slate-900 whitespace-nowrap">
                        Select Vessel:
                    </span>
                    <select
                        value={selectedVessel?._id || ""}
                        onChange={(e) => {
                            const vessel = analysisVessel?.find(
                                (item) => item._id === e.target.value,
                            );
                            setSelectedVessel((prev) => ({
                                ...prev,
                                ...vessel,
                            }));
                        }}
                        name="analysisVessel"
                        className="h-[22px] text-[11px] font-medium px-2 py-0 bg-[#ffffd6] text-slate-900 border border-slate-300 rounded-none focus:outline-none focus:ring-1 focus:ring-amber-600"
                    >
                        <option value="" disabled>
                            Select Vessel
                        </option>
                        {analysisVessel?.map((item, i) => (
                            <option key={i} value={item._id}>
                                {item?.vesselName}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex items-center gap-3 flex-wrap">
                    <div className="flex items-center gap-1.5">
                        <span className="text-[11px] font-medium text-slate-900">
                            Vessel:
                        </span>
                        <input
                            disabled
                            className="h-[22px] text-[11px] font-medium px-2 py-0 bg-[#ffffd6] text-slate-900 border border-slate-300 rounded-none w-36 sm:w-48 disabled:bg-[#ffffd6]"
                            value={parsedVesselData?.vesselName || ""}
                            name="vesselName"
                        />
                    </div>
                    <div className="flex items-center gap-1.5">
                        <span className="text-[11px] font-medium text-slate-900">Dwt:</span>
                        <input
                            disabled
                            className="h-[22px] text-[11px] font-medium px-2 py-0 bg-[#ffffd6] text-slate-900 border border-slate-300 rounded-none w-20 text-center disabled:bg-[#ffffd6]"
                            value={parsedVesselData?.vesselDwt || 0}
                            name="vesselDwt"
                        />
                    </div>
                    <div className="flex items-center gap-1.5">
                        <span className="text-[11px] font-medium text-slate-900">IMO:</span>
                        <input
                            disabled
                            className="h-[22px] text-[11px] font-medium px-2 py-0 bg-[#ffffd6] text-slate-900 border border-slate-300 rounded-none w-20 text-center disabled:bg-[#ffffd6]"
                            value={parsedVesselData?.vesselIMO || 0}
                            name="vesselIMO"
                        />
                    </div>
                </div>
            </div>

            {/* Main Content: Left Column (General Details) + Right Column (Consumptions) */}
            <div className="flex flex-col lg:flex-row items-start gap-1.5">
                {/* Left Column: General Details */}
                <div className="w-full lg:w-5/12">
                    <div className="overflow-x-auto w-full">
                        <table className="vessel-details-tables w-full text-left border-collapse border border-slate-300 table-fixed">
                            <tbody>
                                {vesselCalculatorMainFields?.map((item, key) => (
                                    <tr key={key} className="hover:bg-[#ffffcc]/60 transition-colors">
                                        <th className="w-[45%] px-1.5 py-0 border border-slate-300 bg-white text-[11px] font-medium text-slate-900 align-middle h-[18px]">
                                            {item.label}
                                        </th>
                                        <td className="w-[55%] p-0 border border-slate-300 bg-[#ffffd6] align-middle h-[18px]">
                                            <input
                                                disabled
                                                className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] px-1 py-0 border-none outline-none rounded-none text-left disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                value={
                                                    parsedVesselData?.[item.name] !== undefined && parsedVesselData?.[item.name] !== null
                                                        ? parsedVesselData?.[item.name]
                                                        : item.name === "fuelType"
                                                        ? "Type-1"
                                                        : 0
                                                }
                                                type={item.type}
                                                name={item.name}
                                                readOnly={item.name !== "fuelType"}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Right Column: Consumptions */}
                <div className="w-full lg:w-7/12 flex flex-col gap-1">
                    {/* Ballast Sea Consumptions */}
                    <div>
                        <div className="text-[11px] font-medium text-slate-900 mt-1 mb-1 capitalize tracking-wider">
                            Ballast Sea Consumptions
                        </div>
                        <div className="overflow-x-auto w-full">
                            <table className="vessel-details-tables w-full text-left border-collapse border border-slate-300 table-fixed">
                                <thead>
                                    <tr className="bg-[#f0f2f5]">
                                        <th className="w-[8%] px-1 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">✓</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">Speed</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">Main</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">ECA</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">MGO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {seaConsumptionRows.map((num) => (
                                        <tr key={`ballast-${num}`} className="hover:bg-[#ffffcc]/60 transition-colors">
                                            <td className="p-0 border border-slate-300 align-middle text-center bg-white h-[18px]">
                                                <input
                                                    type="checkbox"
                                                    disabled={true}
                                                    className="w-3 h-3 accent-[#313C4C] cursor-pointer"
                                                    name={`vesselBalComb${num}Selected`}
                                                    checked={
                                                        selectedVessel?.[`vesselBalComb${num}Selected`] ||
                                                        false
                                                    }
                                                    readOnly
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    type="number"
                                                    disabled={true}
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselBalSpd${num}`}
                                                    value={parsedVesselData?.[`vesselBalSpd${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    type="number"
                                                    disabled={true}
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselBalConsmHS${num}`}
                                                    value={parsedVesselData?.[`vesselBalConsmHS${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    type="number"
                                                    disabled={true}
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselBalConsmLS${num}`}
                                                    value={parsedVesselData?.[`vesselBalConsmLS${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    type="number"
                                                    disabled={true}
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselBalConsmMGO${num}`}
                                                    value={parsedVesselData?.[`vesselBalConsmMGO${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Laden Sea Consumptions */}
                    <div>
                        <div className="text-[11px] font-medium text-slate-900 mt-2.5 mb-1 capitalize tracking-wider">
                            Laden Sea Consumptions
                        </div>
                        <div className="overflow-x-auto w-full">
                            <table className="vessel-details-tables w-full text-left border-collapse border border-slate-300 table-fixed">
                                <thead>
                                    <tr className="bg-[#f0f2f5]">
                                        <th className="w-[8%] px-1 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">✓</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">Speed</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">Main</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">ECA</th>
                                        <th className="w-[23%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">MGO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {seaConsumptionRows.map((num) => (
                                        <tr key={`laden-${num}`} className="hover:bg-[#ffffcc]/60 transition-colors">
                                            <td className="p-0 border border-slate-300 align-middle text-center bg-white h-[18px]">
                                                <input
                                                    disabled
                                                    type="checkbox"
                                                    className="w-3 h-3 accent-[#313C4C] cursor-pointer"
                                                    name={`vesselLadComb${num}Selected`}
                                                    checked={
                                                        selectedVessel?.[`vesselLadComb${num}Selected`] ||
                                                        false
                                                    }
                                                    readOnly
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselLdnSpd${num}`}
                                                    value={parsedVesselData?.[`vesselLdnSpd${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselLdnConsmHS${num}`}
                                                    value={parsedVesselData?.[`vesselLdnConsmHS${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselLdnConsmLS${num}`}
                                                    value={parsedVesselData?.[`vesselLdnConsmLS${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`vesselLdnConsmMGO${num}`}
                                                    value={parsedVesselData?.[`vesselLdnConsmMGO${num}`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Port Consumptions */}
                    <div>
                        <div className="text-[11px] font-medium text-slate-900 mt-2.5 mb-1 capitalize tracking-wider">
                            Port Consumptions
                        </div>
                        <div className="overflow-x-auto w-full">
                            <table className="vessel-details-tables w-full text-left border-collapse border border-slate-300 table-fixed">
                                <thead>
                                    <tr className="bg-[#f0f2f5]">
                                        <th className="w-[28%] px-2 py-0.5 border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] text-left align-middle h-[19px]">Type</th>
                                        <th className="w-[24%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">Main</th>
                                        <th className="w-[24%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">ECA</th>
                                        <th className="w-[24%] px-1.5 py-0.5 text-center border border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] align-middle h-[19px]">MGO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {portConsumptionRows.map((row, index) => (
                                        <tr key={`port-${index}`} className="hover:bg-[#ffffcc]/60 transition-colors">
                                            <th className="border border-slate-300 px-2 py-0 text-[11px] font-medium text-slate-900 bg-white text-left align-middle h-[18px]">
                                                {row.tooltip ? (
                                                    <Tooltip
                                                        placement="top"
                                                        arrow
                                                        title={<span className="text-xs">{row.tooltip}</span>}
                                                    >
                                                        <span className="cursor-help border-b border-dotted border-slate-600">
                                                            {row.label}
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    row.label
                                                )}
                                            </th>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`${row.prefix}ConsmHS`}
                                                    value={parsedVesselData?.[`${row.prefix}ConsmHS`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`${row.prefix}ConsmLS`}
                                                    value={parsedVesselData?.[`${row.prefix}ConsmLS`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                            <td className="p-0 border border-slate-300 align-middle bg-[#ffffd6] h-[18px]">
                                                <input
                                                    disabled
                                                    type="number"
                                                    onKeyDown={handleKeyDown}
                                                    placeholder="0"
                                                    name={`${row.prefix}ConsmMGO`}
                                                    value={parsedVesselData?.[`${row.prefix}ConsmMGO`] || 0}
                                                    className="w-full h-[18px] text-[11px] font-medium text-slate-900 bg-[#ffffd6] text-center border-none outline-none rounded-none disabled:bg-[#ffffd6] disabled:text-slate-900"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CreateOperation = ({ setLoader, loader, refetch, onClose, setMaxWidth }) => {
    const [selectedQuery, setSelectedQuery] = useState({});
    const addQueryModalRef = useRef(null);
    const [selectedPorts, setSelectedPorts] = useState([]);
    const [analysisVessel, setAnalysisVessel] = useState([]);
    const [selectedVessel, setSelectedVessel] = useState(null);
    const [opsType, setOpsType] = useState(null);
    const [operationName, setOperationName] = useState("");
    const [activeStep, setActiveStep] = useState(0);
    const isVesselVesselOps = opsType === "vessel-vessel";

    const steps = useMemo(() => {
        if (!opsType) return ["Operation Type"];
        if (opsType === "cargo-cargo")
            return ["Operation Type", "Cargo Details", "Operation Name"];
        if (opsType === "vessel-vessel")
            return [
                "Operation Type",
                "Vessel Details",
                "Counter Party",
                "Operation Name",
            ];
        if (opsType === "vessel-cargo")
            return [
                "Operation Type",
                "Cargo Details",
                "Vessel Details",
                "Counter Party",
                "Operation Name",
            ];
        return [];
    }, [opsType]);

    const currentStepName = steps[activeStep] || "Operation Type";

    useEffect(() => {
        if (!setMaxWidth) return;
        switch (currentStepName) {
            case "Operation Type":
                setMaxWidth("md");
                break;
            case "Cargo Details":
                setMaxWidth("lg");
                break;
            case "Vessel Details":
                setMaxWidth("md");
                break;
            case "Counter Party":
                setMaxWidth("md");
                break;
            case "Operation Name":
                setMaxWidth("sm");
                break;
            default:
                setMaxWidth("md");
                break;
        }
    }, [currentStepName, setMaxWidth]);

    const parsedVesselData = useMemo(() => {
        if (selectedVessel?.vessel && selectedVessel.vessel !== "undefined") {
            try {
                return JSON.parse(selectedVessel.vessel);
            } catch (error) {
                console.error("Error parsing vessel data:", error);
                return null;
            }
        }
        return null;
    }, [selectedVessel]);

    const fetchAnalysisVessel = useCallback(async () => {
        try {
            const res = await getGeneralMasterData("cargo-analysis-vessel-list");
            setAnalysisVessel(res?.data?.list);
        } catch (err) {
            toastError(err?.data?.message || "Something went wrong");
        }
    }, []);

    const [counterPartyDetails, setCounterPartyDetails] = useState();
    const [organizationAddressBook, setOrganizationAddressBook] = useState([]);

    const fetchCounterPartyDetails = async () => {
        const userId = getCurrentUserId();

        try {
            const [userRes, orgRes] = await Promise.all([
                getAddressDetails({ userId, addressBookType: "user", perPage: 100 }),
                getAddressDetails({
                    userId,
                    addressBookType: "organization",
                    perPage: 100,
                }),
            ]);

            setCounterPartyDetails(userRes?.data?.list);
            setOrganizationAddressBook(orgRes?.data?.list);
        } catch (error) {
            console.error("Failed to fetch counter party details:", error);
            setCounterPartyDetails([]);
            setOrganizationAddressBook([]);
        }
    };

    useEffect(() => {
        fetchCounterPartyDetails();
    }, []);

    const onCloseModal = () => {
        setSelectedQuery({});
        setSelectedPorts([]);
    };

    useEffect(() => {
        fetchAnalysisVessel();
    }, [fetchAnalysisVessel]);

    const finalSubmit = () => {
        if (!operationName || !operationName.trim()) {
            toastError("Please enter an operation name");
            return;
        }

        if (opsType === "vessel-vessel" || opsType === "vessel-cargo") {
            if (!selectedVessel?._id) {
                toastError("Please select a vessel");
                return;
            }
            const hasCounterParty =
                selectedVessel?.counterPartyNames &&
                selectedVessel.counterPartyNames.length > 0 &&
                selectedVessel.counterPartyNames.some((item) => item?.id);
            if (!hasCounterParty) {
                toastError("Please select at least one counter party");
                return;
            }
        }

        const data = addQueryModalRef?.current?.getValue();
        let contractData = {
            vesselVesselData: {

            },
            cargoContractData: {

            }
        }
        if (opsType === 'cargo-cargo') {
            contractData.cargoContractData = formateCargoCargoContractData(data, operationName, opsType)
        }

        if (opsType === 'vessel-vessel') {
            const clientQuery = {
                qtyMode: "MOLOO",
                fuelPriceOverridden: false,
                cargoList: [
                    {
                        label: null,
                        voyType: null,
                        account: null,
                        firstLoadPort: null,
                        lastDischargePort: null,
                        cargo: null,
                        freight: null,
                        tcEq: null,
                        tcGbb: null,
                        hire: "",
                        hireGbb: null,
                        profit: null,
                        duration: null,
                        freightMode: null,
                        laycanBegin: null,
                        laycanEnd: null,
                        broker: null,
                        lumpsumFreight: 0,
                        stowFactor: 0,
                        multiParcelMode: null,
                        operation: "Commence",
                        port: selectedVessel?.port,
                        cargoQty: 0,
                        tolerance: 0,
                        rate: 0,
                        terms: "SHINC",
                        turnTime: 0,
                        pdaRemarks: null,
                        grade: null,
                        adcom: 0,
                        brokerage: 0,
                        ttlComm: 0,
                        netFrt: 0,
                        min: 0,
                        max: 0,
                        factor: 1,
                        seaTime: 0,
                        portExp: 0,
                        portStay: 0,
                        extraDays: 0,
                        supply: 0,
                        sulfur: null,
                        loadline: null,
                        dwf: 0,
                        draftRes: 0,
                        waterDensity: 0,
                        other: 0,
                        dischargeQty: 0,
                        speedNormal: 0,
                        speedECA: 0,
                        cargoTx: 0,
                        cargoTxOverriddenValue: 0,
                        arrivalTime: "N/A",
                        departureTime: null,
                        arrivalHsfo: 0,
                        arrivalLsfo: 0,
                        arrivalMgo: 0,
                        departureHsfo: 0,
                        departureLsfo: 0,
                        departureMgo: 0,
                        index: 0,
                        lbmarker: "",
                        lat: selectedVessel?.lat || null,
                        lng: selectedVessel?.lng || null,
                        country: null,
                        portId: null,
                        notes: null,
                        cargoDetails: {
                            distNormal: 0,
                            distEca: 0,
                            bnkrFactor: 0,
                            speedReduce: 0,
                            speedFactor: 0,
                            arrivalBunkersHSFO: 0,
                            arrivalBunkersLSFO: 0,
                            arrivalBunkersMGO: 0,
                            bunkerSuppliedHSFO: 0,
                            bunkerSuppliedLSFO: 0,
                            bunkerSuppliedMGO: 0,
                            bunkerNonScrubberHSFO: 0,
                            bunkerNonScrubberLSFO: 0,
                            bunkerNonScrubberMGO: 0,
                            bunkerScrubberHSFO: 0,
                            bunkerScrubberLSFO: 0,
                            bunkerScrubberMGO: 0,
                            reserve: "Supply",
                            paidBy: "Owner",
                            fuelPriceType0Hsfo: 0,
                            fuelPriceType0Lsfo: 0,
                            fuelPriceType0Mgo: 0,
                            fuelPriceType1Hsfo: 0,
                            fuelPriceType1Lsfo: 0,
                            fuelPriceType1Mgo: 0,
                            fuelPriceType2Hsfo: 0,
                            fuelPriceType2Lsfo: 0,
                            fuelPriceType2Mgo: 0,
                            fuelPriceType3Hsfo: 0,
                            fuelPriceType3Lsfo: 0,
                            fuelPriceType3Mgo: 0,
                            fuelPriceType4Hsfo: 0,
                            fuelPriceType4Lsfo: 0,
                            fuelPriceType4Mgo: 0,
                        },
                        distanceOverridden: false,
                        isExtra: false,
                        version: 0,
                        system: true,
                    },
                    {
                        label: null,
                        voyType: null,
                        account: null,
                        firstLoadPort: null,
                        lastDischargePort: null,
                        cargo: null,
                        freight: "0",
                        tcEq: null,
                        tcGbb: null,
                        hire: "",
                        hireGbb: null,
                        profit: null,
                        duration: null,
                        freightMode: null,
                        laycanBegin: null,
                        laycanEnd: null,
                        broker: null,
                        lumpsumFreight: 0,
                        stowFactor: 0,
                        multiParcelMode: null,
                        operation: "Delivery-out",
                        port: selectedVessel?.port,
                        cargoQty: 0,
                        tolerance: 0,
                        rate: 0,
                        terms: "SHINC",
                        turnTime: 0,
                        pdaRemarks: null,
                        grade: null,
                        adcom: 0,
                        brokerage: 0,
                        ttlComm: 0,
                        netFrt: 0,
                        min: 0,
                        max: 0,
                        factor: 1,
                        seaTime: 0,
                        portExp: 0,
                        portStay: 0,
                        extraDays: 0,
                        supply: 0,
                        sulfur: "Normal",
                        loadline: "S-Summer",
                        dwf: 0,
                        draftRes: 0,
                        waterDensity: 0,
                        other: 0,
                        dischargeQty: 0,
                        speedNormal: 0,
                        speedECA: 0,
                        cargoTx: null,
                        cargoTxOverriddenValue: 0,
                        arrivalTime: "N/A",
                        departureTime: null,
                        arrivalHsfo: null,
                        arrivalLsfo: null,
                        arrivalMgo: null,
                        departureHsfo: null,
                        departureLsfo: null,
                        departureMgo: null,
                        index: 0,
                        lbmarker: null,
                        lat: selectedVessel?.lat || null,
                        lng: selectedVessel?.lng || null,
                        country: null,
                        portId: null,
                        notes: null,
                        distanceOverridden: false,
                        isExtra: true,
                        version: 0,
                        system: true,
                        cargoDetails: {
                            distNormal: 0,
                            distEca: 0,
                            bnkrFactor: 0,
                            speedReduce: 0,
                            speedFactor: 0,
                            arrivalBunkersHSFO: 0,
                            arrivalBunkersLSFO: 0,
                            arrivalBunkersMGO: 0,
                            bunkerSuppliedHSFO: 0,
                            bunkerSuppliedLSFO: 0,
                            bunkerSuppliedMGO: 0,
                            bunkerNonScrubberHSFO: 0,
                            bunkerNonScrubberLSFO: 0,
                            bunkerNonScrubberMGO: 0,
                            bunkerScrubberHSFO: 0,
                            bunkerScrubberLSFO: 0,
                            bunkerScrubberMGO: 0,
                            reserve: "Supply",
                            paidBy: "Owner",
                            fuelPriceType0Hsfo: 0,
                            fuelPriceType0Lsfo: 0,
                            fuelPriceType0Mgo: 0,
                            fuelPriceType1Hsfo: 0,
                            fuelPriceType1Lsfo: 0,
                            fuelPriceType1Mgo: 0,
                            fuelPriceType2Hsfo: 0,
                            fuelPriceType2Lsfo: 0,
                            fuelPriceType2Mgo: 0,
                            fuelPriceType3Hsfo: 0,
                            fuelPriceType3Lsfo: 0,
                            fuelPriceType3Mgo: 0,
                            fuelPriceType4Hsfo: 0,
                            fuelPriceType4Lsfo: 0,
                            fuelPriceType4Mgo: 0,
                        },
                    },
                    {
                        label: null,
                        voyType: null,
                        account: null,
                        firstLoadPort: null,
                        lastDischargePort: null,
                        cargo: null,
                        freight: "0",
                        tcEq: null,
                        tcGbb: null,
                        hire: "",
                        hireGbb: null,
                        profit: null,
                        duration: null,
                        freightMode: null,
                        laycanBegin: null,
                        laycanEnd: null,
                        broker: null,
                        lumpsumFreight: 0,
                        stowFactor: 0,
                        multiParcelMode: null,
                        operation: "Redelivery-in",
                        port: selectedVessel?.port,
                        cargoQty: 0,
                        tolerance: 0,
                        rate: 0,
                        terms: "SHINC",
                        turnTime: 0,
                        pdaRemarks: null,
                        grade: null,
                        adcom: 0,
                        brokerage: 0,
                        ttlComm: 0,
                        netFrt: 0,
                        min: 0,
                        max: 0,
                        factor: 1,
                        seaTime: 0,
                        portExp: 0,
                        portStay: 0,
                        extraDays: 0,
                        supply: 0,
                        sulfur: "Normal",
                        loadline: "S-Summer",
                        dwf: 0,
                        draftRes: 0,
                        waterDensity: 0,
                        other: 0,
                        dischargeQty: 0,
                        speedNormal: 0,
                        speedECA: 0,
                        cargoTx: null,
                        cargoTxOverriddenValue: 0,
                        arrivalTime: "N/A",
                        departureTime: null,
                        arrivalHsfo: null,
                        arrivalLsfo: null,
                        arrivalMgo: null,
                        departureHsfo: null,
                        departureLsfo: null,
                        departureMgo: null,
                        index: 0,
                        lbmarker: null,
                        lat: selectedVessel?.lat || null,
                        lng: selectedVessel?.lng || null,
                        country: null,
                        portId: null,
                        notes: null,
                        distanceOverridden: false,
                        isExtra: true,
                        version: 0,
                        system: true,
                        cargoDetails: {
                            distNormal: 0,
                            distEca: 0,
                            bnkrFactor: 0,
                            speedReduce: 0,
                            speedFactor: 0,
                            arrivalBunkersHSFO: 0,
                            arrivalBunkersLSFO: 0,
                            arrivalBunkersMGO: 0,
                            bunkerSuppliedHSFO: 0,
                            bunkerSuppliedLSFO: 0,
                            bunkerSuppliedMGO: 0,
                            bunkerNonScrubberHSFO: 0,
                            bunkerNonScrubberLSFO: 0,
                            bunkerNonScrubberMGO: 0,
                            bunkerScrubberHSFO: 0,
                            bunkerScrubberLSFO: 0,
                            bunkerScrubberMGO: 0,
                            reserve: "Supply",
                            paidBy: "Owner",
                            fuelPriceType0Hsfo: 0,
                            fuelPriceType0Lsfo: 0,
                            fuelPriceType0Mgo: 0,
                            fuelPriceType1Hsfo: 0,
                            fuelPriceType1Lsfo: 0,
                            fuelPriceType1Mgo: 0,
                            fuelPriceType2Hsfo: 0,
                            fuelPriceType2Lsfo: 0,
                            fuelPriceType2Mgo: 0,
                            fuelPriceType3Hsfo: 0,
                            fuelPriceType3Lsfo: 0,
                            fuelPriceType3Mgo: 0,
                            fuelPriceType4Hsfo: 0,
                            fuelPriceType4Lsfo: 0,
                            fuelPriceType4Mgo: 0,
                        },
                    },
                ],
            }
            // The two vessel contracts can finish at different cargo operations.
            clientQuery.cargoList.push({
                ...clientQuery.cargoList[clientQuery.cargoList.length - 1],
                operation: "Redelivery-out",
                cargoDetails: { ...clientQuery.cargoList[clientQuery.cargoList.length - 1].cargoDetails },
            });
            contractData.vesselContractData = formateVesselVesselContractData({ ...selectedVessel, clientQuery }, operationName, opsType)
        }

        if (opsType === 'vessel-cargo') {
            contractData = formateVesselCargoContractData(selectedVessel, data, operationName, opsType)
        }
        createOperation({ ...contractData, opsName: operationName, opsType: opsType }).then(res => {
            toastSuccess("Operation created successfully");
            onClose();
            refetch();
        }).catch(err => {
            toastError("Failed to create operation");
        })
    };

    const handleNext = () => {
        const currentStep = steps[activeStep];

        if (currentStep === "Operation Type") {
            if (!opsType) {
                toastError("Please select an operation type");
                return;
            }
        } else if (currentStep === "Cargo Details") {
            const data = addQueryModalRef.current?.getValue();
            if (!data) {
                return;
            }
        } else if (currentStep === "Vessel Details") {
            if (!selectedVessel?._id) {
                toastError("Please select a vessel");
                return;
            }
        } else if (currentStep === "Counter Party") {
            const hasCounterParty =
                selectedVessel?.counterPartyNames &&
                selectedVessel.counterPartyNames.length > 0 &&
                selectedVessel.counterPartyNames.some((item) => item?.id);
            if (!hasCounterParty) {
                toastError("Please select at least one counter party");
                return;
            }
        } else if (currentStep === "Operation Name") {
            if (!operationName || !operationName.trim()) {
                toastError("Please enter an operation name");
                return;
            }
        }

        if (activeStep === steps.length - 1) {
            finalSubmit();
            return;
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        setSelectedVessel(null);
        setOpsType(null);
        setOperationName("");
    };

    const addItemAtIndex = (field, index) => {
        setSelectedVessel((prev) => {
            const currentList = prev?.[field] || [];
            const updated = [...currentList];
            updated.splice(index + 1, 0, { name: "", type: "", id: "" });
            return { ...prev, [field]: updated };
        });
    };

    const updateItem = (field, values) => {
        const counterParty =
            field === "organizationAddress"
                ? organizationAddressBook
                : counterPartyDetails;

        setSelectedVessel((prev) => {
            const updatedList = (values || []).map((id) => {
                const cp = counterParty?.find((item) => item._id === id);
                return {
                    id,
                    name:
                        cp?.type === "Individual"
                            ? `${cp?.individual_firstName || ""} ${cp?.individual_lastName || ""}`.trim() ||
                            cp?.fullName ||
                            "Unknown"
                            : cp?.organisation_fullName ||
                            `${cp?.organisation_firstName || ""} ${cp?.organisation_lastName || ""}` ||
                            cp?.fullName ||
                            "Unknown",
                    type: cp?.type || "",
                };
            });

            return { ...prev, [field]: updatedList };
        });
    };

    const deleteItemAtIndex = (field, index) => {
        setSelectedVessel((prev) => {
            const currentList = prev?.[field] || [];
            if (currentList.length <= 1) return prev;

            const updated = [...currentList];
            updated.splice(index, 1);

            return { ...prev, [field]: updated };
        });
    };

    return (
        <Fragment>
            <div className="w-full h-full flex flex-col relative overflow-x-hidden">
                <div className="flex-1 overflow-x-hidden overflow-y-auto pb-[46px]">
                    <div className="w-full overflow-x-auto pb-0 compact-stepper">
                        <Stepper
                            activeStep={activeStep}
                            className="stepper-background !py-0 bg-transparent min-w-[300px]"
                            alternativeLabel
                        >
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>

                    <div className="mt-1 mb-0 w-full">
                        {activeStep === steps.length ? (
                            <div className="flex flex-col items-center justify-center p-8 bg-[#f8fafc] border border-[#e2e8f0] rounded-md text-center mx-2 md:mx-4">
                                <Typography className="text-[14px] font-semibold mb-3 text-[#1e293b]">
                                    All steps completed
                                </Typography>

                                <Button onClick={handleReset} variant="outlined">
                                    Reset
                                </Button>
                            </div>
                        ) : (
                            <Fragment>
                                <div
                                    className={
                                        steps[activeStep] === "Operation Type" ? "block" : "hidden"
                                    }
                                >
                                    <div className="flex flex-col items-center justify-center p-3 md:p-6 w-full max-w-xl mx-auto">
                                        <h2 className="text-sm font-semibold text-[#313C4C] mb-4 text-center">
                                            Select Operation Type
                                        </h2>
                                        <div className="flex flex-col sm:flex-row gap-3 justify-center w-full max-w-2xl">
                                            {["cargo-cargo", "vessel-vessel", "vessel-cargo"].map(
                                                (type) => (
                                                    <div
                                                        key={type}
                                                        onClick={() => setOpsType(type)}
                                                        className={`cursor-pointer px-4 py-2.5 rounded-none border transition-all w-full sm:w-1/3 text-center ${opsType === type
                                                            ? "border-[#313C4C] bg-[#313C4C] text-white shadow-sm"
                                                            : "border-slate-300 bg-white hover:bg-slate-50 text-slate-800"
                                                            }`}
                                                    >
                                                        <h3 className={`font-medium uppercase text-[11px] tracking-wide ${opsType === type ? "text-white" : "text-[#313C4C]"}`}>
                                                            {type.replace("-", " ")}
                                                        </h3>
                                                    </div>
                                                ),
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {steps.includes("Cargo Details") && (
                                    <div
                                        className={
                                            steps[activeStep] === "Cargo Details" ? "block" : "hidden"
                                        }
                                    >
                                        <div className="w-full overflow-x-hidden">
                                            <AddNewOrder
                                                isOpen={true}
                                                ref={addQueryModalRef}
                                                setLoader={setLoader}
                                                loader={loader}
                                                isEdit={false}
                                                onCloseModal={onCloseModal}
                                                selectedQuery={selectedQuery}
                                                selectedPorts={selectedPorts}
                                                isDetailView={true}
                                                disableUploadPdf={true}
                                                isCounterPartySelection={true}
                                            />
                                        </div>
                                    </div>
                                )}

                                {steps.includes("Vessel Details") && (
                                    <div
                                        className={
                                            steps[activeStep] === "Vessel Details"
                                                ? "block"
                                                : "hidden"
                                        }
                                    >
                                        <div className="w-full">
                                            <VesselConsumptions
                                                parsedVesselData={parsedVesselData}
                                                selectedVessel={selectedVessel}
                                                setSelectedVessel={setSelectedVessel}
                                                analysisVessel={analysisVessel}
                                            />
                                        </div>
                                    </div>
                                )}

                                {steps.includes("Counter Party") && (
                                    <div
                                        className={
                                            steps[activeStep] === "Counter Party" ? "block" : "hidden"
                                        }
                                    >
                                        <div className="w-full flex justify-center">
                                            <div className="w-full">
                                                <div className="grid gap-3">
                                                    <div className="w-full bg-white rounded-none p-1 sm:p-2">
                                                        <h2 className="text-[11px] font-semibold text-[#313C4C] mb-2.5 border-b border-slate-300 pb-1.5 uppercase tracking-wider">
                                                            Counter Party Details
                                                        </h2>
                                                        <div className="flex flex-col md:flex-row gap-3">
                                                            <div className="w-full md:w-1/2">
                                                                <CounterPartyList
                                                                    title="Counter Party Details"
                                                                    placeholder="Select Counter Party"
                                                                    hasData={counterPartyDetails?.length > 0}
                                                                    list="counter parties"
                                                                    formDataList={
                                                                        selectedVessel?.counterPartyNames
                                                                    }
                                                                    field="counterPartyNames"
                                                                    getAvailableCounterParties={
                                                                        counterPartyDetails
                                                                    }
                                                                    addItem={addItemAtIndex}
                                                                    updateItem={updateItem}
                                                                    deleteItem={deleteItemAtIndex}
                                                                    createPath="/addressBook"
                                                                />
                                                            </div>
                                                            <div className="w-full md:w-1/2">
                                                                <CounterPartyList
                                                                    title="Brokers"
                                                                    placeholder="Select Broker"
                                                                    hasData={counterPartyDetails?.length > 0}
                                                                    list="brokers"
                                                                    formDataList={selectedVessel?.brokers}
                                                                    field="brokers"
                                                                    getAvailableCounterParties={
                                                                        counterPartyDetails
                                                                    }
                                                                    addItem={addItemAtIndex}
                                                                    updateItem={updateItem}
                                                                    deleteItem={deleteItemAtIndex}
                                                                    createPath="/addressBook"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {!isVesselVesselOps && (
                                                        <div className="w-full bg-white rounded-none p-1 sm:p-2">
                                                            <h2 className="text-[11px] font-semibold text-[#313C4C] mb-2.5 border-b border-slate-300 pb-1.5 uppercase tracking-wider">
                                                                Address Book Details
                                                            </h2>
                                                            <div className="flex flex-col md:flex-row gap-3">
                                                                <div className="w-full md:w-1/2">
                                                                    <CounterPartyList
                                                                        title="My Address Book"
                                                                        placeholder="Select Address Book"
                                                                        hasData={counterPartyDetails?.length > 0}
                                                                        list="my address books"
                                                                        formDataList={selectedVessel?.myAddressBook}
                                                                        field="myAddressBook"
                                                                        getAvailableCounterParties={
                                                                            counterPartyDetails
                                                                        }
                                                                        addItem={addItemAtIndex}
                                                                        updateItem={updateItem}
                                                                        deleteItem={deleteItemAtIndex}
                                                                        createPath="/addressBook"
                                                                    />
                                                                </div>
                                                                <div className="w-full md:w-1/2">
                                                                    <CounterPartyList
                                                                        title="Organization Address"
                                                                        placeholder="Select Org Address"
                                                                        hasData={
                                                                            organizationAddressBook?.length > 0
                                                                        }
                                                                        list="organization address books"
                                                                        formDataList={
                                                                            selectedVessel?.organizationAddress
                                                                        }
                                                                        field="organizationAddress"
                                                                        getAvailableCounterParties={
                                                                            organizationAddressBook
                                                                        }
                                                                        addItem={addItemAtIndex}
                                                                        updateItem={updateItem}
                                                                        deleteItem={deleteItemAtIndex}
                                                                        createPath="/addressBook"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {steps.includes("Operation Name") && (
                                    <div
                                        className={
                                            steps[activeStep] === "Operation Name"
                                                ? "block"
                                                : "hidden"
                                        }
                                    >
                                        <div className="w-full flex justify-center py-4">
                                            <div className="w-full max-w-md bg-white rounded-none p-2 sm:p-3">
                                                <label className="text-[11px] font-semibold text-[#313C4C] mb-2 uppercase tracking-wider block">
                                                    Operation Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="w-full h-[26px] px-2.5 py-0 text-[11px] font-medium text-slate-900 bg-white border border-slate-300 rounded-none focus:border-[#313C4C] focus:outline-none transition-colors"
                                                    value={operationName}
                                                    onChange={(e) => setOperationName(e.target.value)}
                                                    placeholder="Enter Operation Name"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </div>
                </div>

                {activeStep !== steps.length && (
                    <div className="absolute bottom-0 left-0 right-0 border-t border-[#e2e8f0] bg-white z-10">
                        <div className="flex justify-end gap-2 py-1.5 px-4">
                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                variant="outlined"
                                className="!rounded-none !text-[11px] !font-medium !h-7 !px-3 !border-[#cbd5e1] !text-gray-700 hover:!bg-slate-50"
                            >
                                Back
                            </Button>

                            <Button
                                disabled={activeStep === 0 && !opsType}
                                onClick={handleNext}
                                variant="contained"
                                className="!rounded-none !text-[11px] !font-medium !h-7 !px-3 !bg-[#313C4C] hover:!bg-[#1e2632] !text-white shadow-none"
                            >
                                {activeStep === steps.length - 1 ? "Finish" : "Next"}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default CreateOperation;
